
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    userDetails: BehaviorSubject<any> = new BehaviorSubject<any>(null)
    hoteldetailUrl!: string;
    constructor(private auth: AuthService) { }


    public setUser(user: any) {
        if (user) {
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('isLoggedIn', 'true');
            this.auth.UserInfo = user;
            this.auth.isLoggedIn = true;
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('isLoggedIn');
            this.auth.UserInfo = null as any;
            this.auth.isLoggedIn = false;
        }
        this.userDetails.next(user);
    }

    setUrl(url: string) {
        localStorage.setItem("url", url)
    }

    getUrl() {
        const url = localStorage.getItem("url") || ""
        return url;
    }
}